import { useState, useEffect, useCallback } from 'react';
import api from '../api';

/**
 * Server-side access verification hook.
 * Makes an independent POST call to /api/auth/verify to get the REAL auth state
 * directly from the database. The response includes an HMAC _proof that cannot
 * be forged without the server secret — overriding /auth/me in DevTools won't help.
 */
export default function useServerVerify() {
  const [verified, setVerified] = useState(null); // null = loading, object = result
  const [verifying, setVerifying] = useState(true);

  const verify = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setVerified({ has_license: false, isAdmin: false, hasEnterprise: false, isEnterpriseMember: false, hasGVSecurityPlus: false });
      setVerifying(false);
      return;
    }
    try {
      const res = await api.post('/auth/verify');
      const data = res.data;
      // Validate that _proof exists (server-generated, unforgeable)
      if (!data._proof || !data._nonce) {
        setVerified({ has_license: false, isAdmin: false, hasEnterprise: false, isEnterpriseMember: false, hasGVSecurityPlus: false, tampered: true });
      } else {
        setVerified(data);
      }
    } catch (err) {
      // If verify fails (401, network error), deny access
      setVerified({ has_license: false, isAdmin: false, hasEnterprise: false, isEnterpriseMember: false, hasGVSecurityPlus: false });
    } finally {
      setVerifying(false);
    }
  }, []);

  useEffect(() => { verify(); }, [verify]);

  return { verified, verifying, reverify: verify };
}
